module.exports = __webpack_public_path__ + "static/media/AP_Normal_Z1.1a4b5fbd.png";